import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import CustomerSearch from './components/CustomerSearch';
import CustomerDetails from './components/CustomerDetails';
import AuditLog from './components/AuditLog';

export default function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Navigate to="/search" replace />} />
        <Route path="/search" element={<CustomerSearch />} />
        <Route path="/customer/:id" element={<CustomerDetails />} />
        <Route path="/audit" element={<AuditLog />} />
      </Routes>
    </Layout>
  );
}
